module.exports = "<router-view></router-view>\n"